// extracted by mini-css-extract-plugin
module.exports = {"viewFiles":"viewFiles--LYau2","overlayHeader":"overlayHeader--tbQkU","image":"image--K9Lo4","altText":"altText---c1ya"};